import { ResponseDocumentSignature, RequestDocumentSignature } from '../../shared/interfaces';
import { createReducer, on } from '@ngrx/store';
import { DocumentSignatureActions } from '../actions';
import { DocumentSignatureTypes } from '../../shared/enums';

export interface DocumentSignatureState {
    response: ResponseDocumentSignature;
    request: RequestDocumentSignature;
    error: any;
}

export const DocumentSignatureInitialState: DocumentSignatureState = {
    response: null,
    request: null,
    error: null
};

const _documentSignatureReducer = createReducer(
    DocumentSignatureInitialState,

    on(DocumentSignatureActions.getDocumentSignature, (state) => ({
        ...state,
        request: null,
        error: null
    })),

    on(DocumentSignatureActions.getDocumentSignatureSucess, (state, { response }) => ({
        ...state,
        response,
        error: null
    })),

    on(DocumentSignatureActions.getDocumentSignatureError, (state, { payload }) => ({
        ...state,
        request: null,
        response: null,
        error: {
            statusCode: payload.statusCode,
            message: payload.message
        }
    })),

    on(DocumentSignatureActions.cleanState, (state) => ({
        ...state,
        request: null,
        response: null,
        error: null
    }))
);

export function documentSignatureReducer(state, action) {
    if (action.type === DocumentSignatureTypes.DOCUMENT_SIGNATURE) {
        state = undefined;
    }
    return _documentSignatureReducer(state, action);
}
